import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { useCompanyUserCertificates } from '../../../hooks/api/company-user-certificates/useCompanyUserCertificates';
import { useUser } from '../../../hooks/api/users/useUser';
import { useFilterQuery } from '../../../hooks/useFilterQuery';
import { useCompany } from '../../../providers/company';
import AdminSubHeader from '../../layouts/partials/AdminSubheader';
import CertificatesListView from '../../shared/certificates/CertificatesListView';
import { CreateCertificateButton } from '@shared/certificates/components/CreateCertificateButton';

type Props = RouteComponentProps<{
  id: string;
}> & {};

function StatusBadge({ status }: { status: 'pending' | 'rejected' | 'approved' | 'expired' }) {
  const statusColors = {
    pending: 'warning',
    rejected: 'danger',
    approved: 'success',
    expired: 'metal',
  };

  return <span className={`m-badge m-badge--${statusColors[status]} m-badge--wide`}>{status}</span>;
}

export default function CompanyEmployeeCertificates({ match }: Props) {
  const { data: user } = useUser(Number(match.params.id));
  const company = useCompany()!;
  const filters = useFilterQuery();
  const [listFilters, setListFilters] = useState(filters);
  const { data, isLoading, refetch } = useCompanyUserCertificates(company.id, user?.id, { ...listFilters });

  useEffect(() => {
    if (user) {
      refetch();
    }
  }, [listFilters]);

  if (!user || !company) {
    return <p>Loading...</p>;
  }

  return (
    <>
      <AdminSubHeader title={`Certificates for ${user.fullName}`}>
        <CreateCertificateButton companyId={company.id} userId={user.id} />
      </AdminSubHeader>
      <div className="m-content">
        <div className="row">
          <div className="col-xl-12">
            {isLoading && <div className="alert alert-info">Loading...</div>}

            {data && <CertificatesListView onFiltersChange={setListFilters} filters={listFilters} data={data} />}
          </div>
        </div>
      </div>
    </>
  );
}
